import React, { useState } from "react";
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

const Footer = () => {

    const [expanded, setExpanded] = React.useState<string | false>(false);

    const handleClickAccordion =
        (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
            setExpanded(isExpanded ? panel : false);
        }

    return <>
        <div className="container-section-appointment-temptation">
            <div className="section-pink">
                <div className=" section-pink1">
                    <div className="font-bask">
                        Vivi l'esperienza
                        di Temptation's Gallery
                    </div>
                    <div style={{ fontSize: "1rem" }}>
                        Prova il tuo abito in Atelier e vivi,
                        assieme ai tuoi cari, un’esperienza unica.
                        Con l’aiuto delle nostre consulenti potrai provare tutti gli abiti che ami, fino a trovare
                        il
                        vestito perfetto per il tuo si.
                    </div>
                </div>
                <div className=" section-pink2">
                    <div className="accordion-container">

                        <Accordion expanded={expanded === 'panel1'} onChange={handleClickAccordion('panel1')}>
                            <AccordionSummary
                                expandIcon={<img className="arrow-down-accordion"
                                    src="/calendario-appuntamenti/images/arrow-down-sign-to-navigate.png" />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                                <Typography component="span"><div className="accordion-header">Prima dell'appuntamento </div></Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <p>Divertiti a creare la tua lista desideri sul sito. Naviga per stile o per brand e
                                    aggiungi gli abiti che preferisci. Quando vuoi contattaci, anche su Whatsapp,
                                    per <b style={{ fontWeight: "600" }}>prenotare un appuntamento</b> o chiedere
                                    informazioni.
                                    Le nostre consulenti sono al tuo servizio per esigenza.</p>

                                <p>Scegli chi portare con te all’appuntamento, famigliari o amici che ti aiutino
                                    nella
                                    scelta. Potranno offrirti un punto di vista che solo chi ti conosce davvero può
                                    darti.</p>
                            </AccordionDetails>
                        </Accordion>

                        {/* <div className="accordion">
                <div className="accordion-header">Prima dell'appuntamento <img className="arrow-down-accordion"
                  src="/calendario-appuntamenti/images/arrow-down-sign-to-navigate.png" /></div>
                <div className="accordion-content">
                  <p>Divertiti a creare la tua lista desideri sul sito. Naviga per stile o per brand e
                    aggiungi gli abiti che preferisci. Quando vuoi contattaci, anche su Whatsapp,
                    per <b style={{ fontWeight: "600" }}>prenotare un appuntamento</b> o chiedere
                    informazioni.
                    Le nostre consulenti sono al tuo servizio per esigenza.</p>

                  <p>Scegli chi portare con te all’appuntamento, famigliari o amici che ti aiutino
                    nella
                    scelta. Potranno offrirti un punto di vista che solo chi ti conosce davvero può
                    darti.</p>
                </div>
              </div> */}

                        <Accordion expanded={expanded === 'panel2'} onChange={handleClickAccordion('panel2')}>
                            <AccordionSummary
                                expandIcon={<img className="arrow-down-accordion"
                                    src="/calendario-appuntamenti/images/arrow-down-sign-to-navigate.png" />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                                <Typography component="span"><div className="accordion-header">Durante l'appuntamento </div></Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <p>Una delle nostre consulenti, una professionsta del wedding, sarà a tua
                                    disposizione
                                    per
                                    tutto il percorso. Faremo una chiacchierata amichevole per conoscere i tuoi
                                    gusti e
                                    vedere la tua lista desideri.
                                </p>

                                <p>Ti aiuteremo a scegliere lo stile che più ti si addice.</p>

                                <p>Avrai un salotto a disposizione per te e i tuoi cari dove potrai vederti tu
                                    stessa e
                                    mostrare l’abito indossato.</p>

                                <p>
                                    <strong> Cosa indossare?</strong>
                                </p>

                                <p>Vestiti comoda, ti consigliamo di indossare della biancheria intima bianca o
                                    color
                                    carne, meglio se il reggiseno è senza spalline ma non è essenziale.</p>

                                <p>Prima di tutto ricorda di divertirti! La scelta dell’abito sarà un esperienza
                                    meravigliosa e noi siamo qui per aiutarti a renderla unica.</p>

                                <p>
                                    <strong>
                                        Se decidi che “è quello giusto”?
                                    </strong>
                                </p>

                                <p>
                                    Prendiamo le tue misure e concordiamo con te tutte le personalizzazioni che le
                                    nostre
                                    sarte apporteranno al tuo abito, anche considerando eventuali cambi di peso, gli
                                    adattamenti necessari e naturalmente gli accessori.
                                </p>
                            </AccordionDetails>
                        </Accordion>

                        {/* <div className="accordion">
                <div className="accordion-header">Durante l'appuntamento <img className="arrow-down-accordion"
                  src="/calendario-appuntamenti/images/arrow-down-sign-to-navigate.png" /></div>
                <div className="accordion-content">
                  <p>Una delle nostre consulenti, una professionsta del wedding, sarà a tua
                    disposizione
                    per
                    tutto il percorso. Faremo una chiacchierata amichevole per conoscere i tuoi
                    gusti e
                    vedere la tua lista desideri.
                  </p>

                  <p>Ti aiuteremo a scegliere lo stile che più ti si addice.</p>

                  <p>Avrai un salotto a disposizione per te e i tuoi cari dove potrai vederti tu
                    stessa e
                    mostrare l’abito indossato.</p>

                  <p>
                    <strong> Cosa indossare?</strong>
                  </p>

                  <p>Vestiti comoda, ti consigliamo di indossare della biancheria intima bianca o
                    color
                    carne, meglio se il reggiseno è senza spalline ma non è essenziale.</p>

                  <p>Prima di tutto ricorda di divertirti! La scelta dell’abito sarà un esperienza
                    meravigliosa e noi siamo qui per aiutarti a renderla unica.</p>

                  <p>
                    <strong>
                      Se decidi che “è quello giusto”?
                    </strong>
                  </p>

                  <p>
                    Prendiamo le tue misure e concordiamo con te tutte le personalizzazioni che le
                    nostre
                    sarte apporteranno al tuo abito, anche considerando eventuali cambi di peso, gli
                    adattamenti necessari e naturalmente gli accessori.
                  </p>
                </div>
              </div> */}

                        <Accordion expanded={expanded === 'panel3'} onChange={handleClickAccordion('panel3')}>

                            <AccordionSummary
                                expandIcon={<img className="arrow-down-accordion"
                                    src="/calendario-appuntamenti/images/arrow-down-sign-to-navigate.png" />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                                <Typography component="span"><div className="accordion-header">Personalizzazioni e accessori </div></Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <p>Decideremo con te le date delle prove, la tua <strong>consulente
                                    personale</strong>
                                    ti seguirà negli
                                    incontri che serviranno a rendere ogni abito unico. seguendoti fino al giorno in
                                    cui
                                    indosserai l’abito per il fatidico si.</p>

                                <p>Le nostre sarte, con oltre 20 anni di esperienza, hanno lavorato su migliaia di
                                    abiti, sapranno rendere unico il tuo abito, per renderlo proprio come lo hai
                                    sempre
                                    sognato.</p>

                                <p>Da Temptation’s Gallery potrai scegliere tutti gli <strong>accessori che ti
                                    servono</strong> per
                                    completare il tuo look. Dai coprispalle, al velo fino alle scarpe. Puoi anche
                                    portare i tuoi accessori se prferisci, troveremo sempre la combinazione perfetta
                                    per
                                    renderti felice. </p>
                            </AccordionDetails>
                        </Accordion>

                        {/* <div className="accordion">
                <div className="accordion-header">Personalizzazioni e accessori <img
                  className="arrow-down-accordion" src="/calendario-appuntamenti/images/arrow-down-sign-to-navigate.png" /></div>
                <div className="accordion-content">
                  <p>Decideremo con te le date delle prove, la tua <strong>consulente
                    personale</strong>
                    ti seguirà negli
                    incontri che serviranno a rendere ogni abito unico. seguendoti fino al giorno in
                    cui
                    indosserai l’abito per il fatidico si.</p>

                  <p>Le nostre sarte, con oltre 20 anni di esperienza, hanno lavorato su migliaia di
                    abiti, sapranno rendere unico il tuo abito, per renderlo proprio come lo hai
                    sempre
                    sognato.</p>

                  <p>Da Temptation’s Gallery potrai scegliere tutti gli <strong>accessori che ti
                    servono</strong> per
                    completare il tuo look. Dai coprispalle, al velo fino alle scarpe. Puoi anche
                    portare i tuoi accessori se prferisci, troveremo sempre la combinazione perfetta
                    per
                    renderti felice. </p>
                </div>
              </div> */}
                    </div>
                </div>
            </div>
        </div>

        <div className="container-section-appointment-temptation">
            <div className="section-vademecum-temptation">
                <div>
                    <div className="section1-vademecum">
                        <div className="divider"></div>
                        <div>Come funziona</div>
                    </div>
                </div>
                <div className="section2-vademecum">
                    <div className="row-vademecum">
                        <div className="row-icon"> <img className="icon" src="/calendario-appuntamenti/images/mobile-phone.png" />Registrati sul sito</div>
                        <div className="row-icon"><img style={{ width: "50px" }} src="/calendario-appuntamenti/images/heart.png" className="icon" />Crea la tua
                            lista
                        </div>
                    </div>
                    <div className="row-vademecum">
                        <div className="row-icon"><img style={{ width: "40px" }} src="/calendario-appuntamenti/images/calendar.png" className="icon" />Fissa
                            appuntamento</div>
                        <div className="row-icon"><img src="/calendario-appuntamenti/images/stylist.png" className="icon" />Prova gli abiti</div>
                    </div>
                </div>
            </div>
        </div>
    </>
}

export default Footer